module.exports = __webpack_public_path__ + "img/d2.4b2d9eb9.png";